const initialState = {
    levelOneList: [],
    isFetchingLevelOne: false,
};

const LevelOneReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_GET_LEVELONE":
            return { ...state, isFetchingLevelOne: true };
        case "SUCCESS_GET_LEVELONE":
            return { ...state, levelOneList: action.payload, isFetchingLevelOne: false };
        case "ERROR_GET_LEVELONE":
            return { ...state, isFetchingLevelOne: false };


        default:
            return state;
    }
};

export default LevelOneReducer;